import { Anchor, Checkbox, Text } from '@mantine/core';

export const LegalCheckbox = ({
    value,
    onChange,
    onReset,
    isDowngrade,
    error,
}: {
    value: boolean;
    onChange: (value: boolean) => void;
    onReset: () => void;
    isDowngrade?: boolean;
    error?: boolean;
}) => {
    if (isDowngrade) {
        return null;
    }

    return (
        <Checkbox
            checked={value}
            onChange={() => {
                onChange(!value);
                onReset();
            }}
            label={
                <Text c={error ? 'red' : ''}>
                    By signing up, you agree to the listed subscription fees and accept the{' '}
                    <Anchor c="inherit" href="/subscription-agreement-designer-ai.pdf" target="_blank">
                        Subscription Agreement
                    </Anchor>
                    .
                </Text>
            }
        />
    );
};
